/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IBreadcrumbsData } from './breadcrumbs.data';
import { IBreadcrumbsProps } from './breadcrumbs.props.autogenerated';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';
import { ICategoryUrl } from '@msdyn365-commerce/core-internal/dist/types/interfaces/ICategoryPathInterfaces';

export interface IBreadcrumbsViewProps extends IBreadcrumbsProps<IBreadcrumbsData> {
    categoryPaths: AsyncResult<ICategoryUrl[]>;
}

/**
 *
 * Breadcrumbs component
 * @extends {React.PureComponent<IBreadcrumbsProps<IBreadcrumbsData>>}
 */
class Breadcrumbs extends React.PureComponent<IBreadcrumbsProps<IBreadcrumbsData>> {
    public render(): JSX.Element | null {
        const viewProps: IBreadcrumbsViewProps = {
            ...this.props,
            categoryPaths: this.props.data.categoryPaths
        };

        return this.props.renderView(viewProps);
    }
}

export default Breadcrumbs;
